import { Icon } from '@chakra-ui/react';
import React from 'react';

const Home = props => {
  return (
    <Icon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.02024 2.84004L3.63024 7.04004C2.73024 7.74004 2.00024 9.23004 2.00024 10.36V17.77C2.00024 20.09 3.89024 21.99 6.21024 21.99H17.7902C20.1102 21.99 22.0002 20.09 22.0002 17.78V10.5C22.0002 9.29004 21.1902 7.74004 20.2002 7.05004L14.0202 2.72004C12.6202 1.74004 10.3702 1.79004 9.02024 2.84004Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.99V14.99"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default Home;
